import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLinkedin = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={18} height={18} fill='currentColor' {...props}>
    <path d='M1.714.017A1.714 1.714 0 0 0 0 1.73v13.714a1.72 1.72 0 0 0 1.714 1.715H15.43a1.715 1.715 0 0 0 1.714-1.715V1.731A1.715 1.715 0 0 0 15.429.017zm3.429 6.857v7.714H2.57V6.874zm.274-2.623c0 .771-.574 1.38-1.5 1.38H3.9c-.891 0-1.457-.609-1.457-1.372 0-.788.583-1.388 1.491-1.388s1.466.6 1.483 1.371zM9.43 14.588H6.857s.034-6.96 0-7.714H9.43v1.003a2.34 2.34 0 0 1 2.142-1.183c1.74 0 3 .994 3 3.454v4.44H12v-4.131c0-1.08-.309-1.818-1.269-1.818-.831 0-1.302.909-1.302 1.629z' />
  </svg>
);
export default SvgLinkedin;
